<template>
	<Dialog
		:header="headerText"
		:visible="showDialog"
		:breakpoints="{'960px': '80vw', '640px': '100vw'}"
		@hide="onCloseDialog"
		:modal="true"
		:closable="false"
		position="top"
		:closeOnEscape="false"
	>
		{{$t('Squeeze.Validation.Dialogs.Locked.LockedByLongText')}}<br/><br/>
		<div v-if="isUserAdmin">
			{{$t('Squeeze.Validation.Dialogs.Locked.NextDocumentOrList')}}<br/><br/>
			{{$t('Squeeze.Validation.Dialogs.Locked.TakeOverMessage')}}
		</div>
		<div v-else>
			{{$t('Squeeze.Validation.Dialogs.Locked.ShowDocumentOrList')}}<br/><br/>
			{{$t('Squeeze.Validation.Dialogs.Locked.NoEditDocument')}}
		</div>

		<template #footer>
			<Button v-if="isUserAdmin"
					:label="$t('Squeeze.Validation.Dialogs.Locked.UnlockDocument')"
					icon="mdi mdi-sort-variant-lock-open"
					class="p-button-text"
					@click="$emit('unlockDocument')"
			/>
			<Button :label="$t('Squeeze.Validation.Dialogs.Locked.ShowOnly')"
					icon="mdi mdi-eye-outline"
					class="p-button-text"
					@click="$emit('showOnly')"
			/>
			<Button :label="$t('Squeeze.Validation.Buttons.NextDocument')"
					icon="mdi mdi-chevron-right"
					class="p-button-text"
					@click="$emit('nextDocument')"
			/>
			<Button :label="$t('Squeeze.Validation.Dialogs.Locked.ToOverview')"
					icon="mdi mdi-skip-backward"
					class="p-button-text"
					@click="$emit('backToOverview')"
			/>
		</template>
	</Dialog>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref, watch} from 'vue';
import {useI18n} from "vue-i18n";
import {useToast} from "primevue/usetoast";
import useSqueezeStore from "@/apps/squeeze/store";
import {ClientManager} from "@/singletons/ClientManager";
import Dialog from "primevue/dialog";
import Button from "primevue/button";

export default defineComponent({
	name: "DialogLocked",
	components: {
		Dialog,
		Button,
	},
	props: {
		/** Should the dialog be shown? */
		showDialog: {
			type: Boolean,
			default: false,
		},
		/** ID of the blocking user */
		lockingUserId: {
			type: Number,
			default: null,
		},
	},
	emits: ["closeDialog", "unlockDocument", "backToOverview", "showOnly", "nextDocument"],
	setup(props, { emit }) {
		const {t} = useI18n();
		const toast = useToast();

		/** Current Vuex-Store */
		const store = useSqueezeStore();

		/** Text of the header */
		const headerText = ref<string>('');

		/** Name of the current user */
		const userName = ref<string>("mir!");

		/** Is user a admin? */
		const isUserAdmin = ref<boolean>(false);

		/** User API endpoint */
		const userApi = ClientManager.getInstance().squeeze.user;

		/** Triggered when dialog closed */
		const onCloseDialog = () => {
			emit("closeDialog");
		}

		/** Reload user data to get the name of the user that blocked the document */
		const reloadUserData = () => {
			if (props.lockingUserId) {
				userApi.getUserById(props.lockingUserId)
					.then(data => {
						userName.value = data.firstName + " " + data.lastName;
						headerText.value = t('Squeeze.Validation.Dialogs.Locked.DocumentLockedBy', { userName: userName.value });
					})
			}
		}

		onMounted(() =>{
			headerText.value = t('Squeeze.Validation.Dialogs.Locked.DocumentLocked');
			isUserAdmin.value = !!store.state.isAdminUser;
		})

		/** Watch prop at set value object, because props are not allowed to be mutated */
		watch(() => props.lockingUserId,() => {
			reloadUserData();
		})

		return {
			t,
			toast,
			store,
			headerText,
			userName,
			isUserAdmin,
			onCloseDialog,
			reloadUserData,
		};
	},
});

</script>

<style scoped>
</style>
